import React from "react";
import invest from "@frameworks/web/assets/images/features/Markets/MutualFunds/InvestinMF/invest.svg";
import manage from "@frameworks/web/assets/images/features/Markets/MutualFunds/InvestinMF/manage.svg";
import returns from "@frameworks/web/assets/images/features/Markets/MutualFunds/InvestinMF/returns.svg";
import equity from "@frameworks/web/assets/images/features/Markets/MutualFunds/TopPerformingFunds/equityfund.png";
import hybrid from "@frameworks/web/assets/images/features/Markets/MutualFunds/TopPerformingFunds/hybrid.svg";
import tax from "@frameworks/web/assets/images/features/Markets/MutualFunds/TopPerformingFunds/tax.svg";
import { EFundTabs } from "@frameworks/shared-library/components/TopPerformingFunds/constants";
import { ESortOrder } from "@domains/utils/sort";
import { Sorts, } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { MFCategoriesCode, MFSchemesPlanTypes, MFSchemsPlanes, } from "@domains/features/Markets/MutualFunds/entities/MFCommon";
export var investInMf = [
    {
        text: (React.createElement(React.Fragment, null,
            "Start investing",
            React.createElement("br", null),
            "as low as \u20B9500")),
        image: invest,
    },
    {
        text: (React.createElement(React.Fragment, null,
            "Higher",
            React.createElement("br", null),
            "Returns")),
        image: returns,
    },
    {
        text: (React.createElement(React.Fragment, null,
            "Managed by",
            React.createElement("br", null),
            "professionals")),
        image: manage,
    },
];
export var performingFunds = [
    {
        image: equity,
        text: "Equity Funds",
        description: "Long term Wealth Creation",
        key: EFundTabs.EQUITY,
    },
    {
        image: hybrid,
        text: "Hybrid Funds",
        description: "Benefits of Equity & Debt MF",
        key: EFundTabs.HYBRID,
    },
    {
        image: tax,
        text: "Tax Savings",
        description: "Wealth Generation & Tax Savings",
        key: EFundTabs.TAX,
    },
];
export var NewMutualSortList = [
    new Sorts([
        {
            title: "1 Year",
            key: "year1",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        },
        {
            title: "3 Year CAGR",
            key: "year3",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        },
        {
            title: "5 Year CAGR",
            key: "year5",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        },
    ], "Returns"),
    new Sorts([
        {
            title: "Name",
            key: "schemeName",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Z to A", desc: "A to Z" },
            type: "string",
        },
        {
            title: "AUM",
            key: "aum",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        },
    ], ""),
];
export var fundTabs = [
    { title: "Equity", eventKey: EFundTabs.EQUITY },
    { title: "Hybrid", eventKey: EFundTabs.HYBRID },
    { title: "Tax Saving", eventKey: EFundTabs.TAX },
];
export var fundFilters = [
    {
        filterName: "Category",
        list: [
            { title: "Equity", key: MFCategoriesCode.EQUITY, selected: false },
            { title: "Debt", key: MFCategoriesCode.DEBT, selected: false },
            { title: "Hybrid", key: MFCategoriesCode.HYBRID, selected: false },
            { title: "Others", key: MFCategoriesCode.OTHERS, selected: false },
        ],
        selectType: "radio",
    },
    {
        filterName: "Sub Category",
        selectType: "checkbox",
        list: [],
        // clear: true,
    },
    {
        filterName: "Scheme Type",
        nestedList: [
            {
                subFilter: "Regular/Direct",
                list: [
                    {
                        title: "Regular",
                        key: MFSchemesPlanTypes.REGULAR,
                        selected: false,
                    },
                    { title: "Direct", key: MFSchemesPlanTypes.DIRECT, selected: false },
                ],
                selectType: "radio",
            },
            {
                subFilter: "Plan",
                list: [
                    { title: "Growth", key: MFSchemsPlanes.GROWTH, selected: false },
                    { title: "IDCW", key: MFSchemsPlanes.IDCW, selected: false },
                ],
                selectType: "radio",
            },
        ],
    },
    {
        filterName: "AUM Size in Cr",
        selectType: "text",
        clear: true,
    },
    {
        filterName: "Fund House",
        selectType: "checkbox",
        list: [],
    },
];
export var tipsdatalist = [
    {
        description: "For regular and disciplined wealth creation you should start investing via SIP.",
    },
    {
        description: "SIP helps you average your cost by investing regularly at various market levels and maximise returns.",
    },
    {
        description: "Lumpsum is ideal when you just received some large cash-flow like annual bonus, etc.",
    },
    {
        description: "Any surplus savings (monthly savings or surplus in savings account) which is not expected to be needed for any essential expenses over the next 3 years should be considered for investments in equity mutual funds.",
    },
    {
        description: "Diversify your investments across Mutual Funds and maintain asset allocation  based on your profile (age, life stage etc).",
    },
    {
        description: "Based on your profile you can have higher equity asset allocation at a younger age and your portfolio can gradually move towards fixed income (lower risk assets) as your life stage matures towards retirement.",
    },
    {
        description: "Periodically monitor performance of your investments and Mutual Funds you have invested in for rebalancing requirements.",
    },
];
